import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEntertainment = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	stroke: "currentColor",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 14V3L9 5V16M20 14V17C20 18.1046 19.1046 19 18 19H17C15.8954 19 15 18.1046 15 17V16C15 14.8954 15.8954 14 17 14H20ZM9 16V19C9 20.1046 8.10457 21 7 21H6C4.89543 21 4 20.1046 4 19V18C4 16.8954 4.89543 16 6 16H9Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgEntertainment;
